import { Link } from "react-router-dom";
import Breadcrumbs from "../../styles/components/Breadcrumbs";
import "../../styles/pages/content/_administration.scss";

export default function AdministrationFlags() {
    return (
        <div className="adm-sub" id="administration-flags">
            <div className="adm-sub__inner">
                <Breadcrumbs
                    items={[
                        { label: "Home", href: "/" },
                        { label: "Administration", href: "/administration" },
                        {
                            label: "Feature flags",
                            href: "/administration/flags",
                        },
                    ]}
                />

                <div className="adm-sub__header">
                    <div>
                        <p className="adm-sub__eyebrow">Administration</p>
                        <h1 className="adm-sub__title">Feature flags</h1>
                        <p className="adm-sub__sub">
                            Roll out betas safely and control access per cohort
                            or organisation.
                        </p>
                    </div>
                </div>

                <section className="adm-sub__panel">
                    <h2>Overview</h2>
                    <p>
                        Toggle new features for pilot programs before wider
                        release.
                    </p>
                </section>
            </div>
        </div>
    );
}
